'use strict';

module.exports = function ($stateProvider)
{
    $stateProvider
    // Failed SSL Certificate Validation
    .state('pages.main.ssl_certs',
    {
        url: '/ssl_certs',
        template: require('../views/hunting/ssl_certs.html'),
        controller: 'sslCertsController',
        controllerAs: 'page',
        data:
        {
            title: 'Failed SSL Certificate Validations',
            daterange: true
        }
    })
    // DNS Exfiltration (UDP Tunneling)
    .state('pages.main.dns_exfil_udp_tunnels',
    {
        url: '/dns_exfil_udp_tunnels',
        template: require('../views/hunting/dns_exfil_udp_tunnels.html'),
        controller: 'dnsExfilTunnelsController',
        controllerAs: 'page',
        data:
        {
            title: 'DNS Exfiltration (UDP Tunneling) [> 60sec]',
            daterange: true
        }
    })
    // DNS Exfiltration (Subdomains on a Top Level Domain)
    .state('pages.main.dns_exfil_subdomains',
    {
        url: '/dns_exfil_subdomains',
        template: require('../views/hunting/dns_exfil_subdomains.html'),
        controller: 'dnsExfilSubdomainsController',
        controllerAs: 'page',
        data:
        {
            title: 'Subdomains Stacking',
            daterange: true
        }
    })
    // DNS Exfiltration (DNS Queries)
    // .state('pages.main.dns_exfil_queries',
    // {
    //     url: '/dns_exfil_queries',
    //     template: require('../views/hunting/dns_exfil_queries.html'),
    //     controller: 'dnsExfilQueriesController',
    //     controllerAs: 'page',
    //     data:
    //     {
    //         title: 'DNS Exfiltration (DNS Queries) Events',
    //         daterange: true
    //     }
    // })
    // Kaminsky DNS Attack (Duplicate DNS Source Ports)
    .state('pages.main.dns_poisoning',
    {
        url: '/dns_poisoning',
        template: require('../views/hunting/dns_poisoning.html'),
        controller: 'dnsPoisoning',
        controllerAs: 'page',
        data:
        {
            title: 'Kaminsky DNS Attack (Duplicate DNS Source Ports)',
            daterange: true
        }
    })
    // DNS Tunnel (DNScat2)
    .state('pages.main.dns_tunnel_dnscat2',
    {
        url: '/dns_tunnel_dnscat2',
        template: require('../views/hunting/dns_tunnel_dnscat2.html'),
        controller: 'dnsTunnelDnscat2',
        controllerAs: 'page',
        data:
        {
            title: 'DNS Tunnel (DNScat2)',
            daterange: true
        }
    })
    // DNS Tunnel (Iodine-1)
    .state('pages.main.dns_tunnel_iodine_1',
    {
        url: '/dns_tunnel_iodine_1',
        template: require('../views/hunting/dns_tunnel_iodine_1.html'),
        controller: 'dnsTunnelIodine1',
        controllerAs: 'page',
        data:
        {
            title: 'Iodine DNS Tunnel (DNS null returns)',
            daterange: true
        }
    })
    // DNS Tunnel (Iodine-2)
    .state('pages.main.dns_tunnel_iodine_2',
    {
        url: '/dns_tunnel_iodine_2',
        template: require('../views/hunting/dns_tunnel_iodine_2.html'),
        controller: 'dnsTunnelIodine2',
        controllerAs: 'page',
        data:
        {
            title: 'DNS Tunnel (Iodine-2)',
            daterange: true
        }
    })
    // Suspicious Subdomains
    .state('pages.main.dns_exfil_queries',
    {
        url: '/suspicious_subdomains',
        template: require('../views/hunting/suspicious_subdomains.html'),
        controller: 'suspiciousSubdomains',
        controllerAs: 'page',
        data:
        {
            title: 'Suspicious Subdomains',
            daterange: true
        }
    })
    // Long Duration Connections
    .state('pages.main.long_duration_conns',
    {
        url: '/long_duration_conns',
        template: require('../views/hunting/long_duration_conns.html'),
        controller: 'longDurationConns',
        controllerAs: 'page',
        data:
        {
            title: 'Long Duration Connections [> 60sec]',
            daterange: true
        }
    })
    // Large HTTP Responses (More than 1KB)
    .state('pages.main.large_http_responses',
    {
        url: '/large_http_responses',
        template: require('../views/hunting/large_http_responses.html'),
        controller: 'largeHttpResponses',
        controllerAs: 'page',
        data:
        {
            title: 'Large HTTP Responses [> 1KB]',
            daterange: true
        }
    })
    // Non-Standard HTTP
    .state('pages.main.non_standard_http',
    {
        url: '/non_standard_http',
        template: require('../views/hunting/non_standard_http.html'),
        controller: 'nonStandardHttp',
        controllerAs: 'page',
        data:
        {
            title: 'Non-Standard HTTP',
            daterange: true
        }
    })
    // Services Breakdown
    .state('pages.main.services_breakdown',
    {
        url: '/services_breakdown',
        template: require('../views/hunting/services_breakdown.html'),
        controller: 'servicesBreakdown',
        controllerAs: 'page',
        data:
        {
            title: 'Services Breakdown',
            daterange: true
        }
    })
    // User-Agents (HTTP)
    .state('pages.main.user_agents',
    {
        url: '/user_agents',
        template: require('../views/hunting/user_agents.html'),
        controller: 'userAgents',
        controllerAs: 'page',
        data:
        {
            title: 'User-Agents (HTTP)',
            daterange: true
        }
    })
    // Top Responder Ports
    .state('pages.main.top_responder_ports',
    {
        url: '/top_responder_ports',
        template: require('../views/hunting/top_responder_ports.html'),
        controller: 'topResponderPorts',
        controllerAs: 'page',
        data:
        {
            title: 'Top Responder Ports',
            daterange: true
        }
    })
    // Top Internal Producers
    .state('pages.main.top_internal_producers',
    {
        url: '/top_internal_producers',
        template: require('../views/hunting/top_internal_producers.html'),
        controller: 'topInternalProducers',
        controllerAs: 'page',
        data:
        {
            title: 'Top Internal Producers',
            daterange: true
        }
    })
    // Top Referred Hosts
    .state('pages.main.top_referred_hosts',
    {
        url: '/top_referred_hosts',
        template: require('../views/hunting/top_referred_hosts.html'),
        controller: 'topReferredHosts',
        controllerAs: 'page',
        data:
        {
            title: 'Top Referred Hosts',
            daterange: true
        }
    })
    // Most Popular Sites
    .state('pages.main.most_popular_sites',
    {
        url: '/most_popular_sites',
        template: require('../views/hunting/most_popular_sites.html'),
        controller: 'mostPopularSites',
        controllerAs: 'page',
        data:
        {
            title: 'Most Popular Sites',
            daterange: true
        }
    })
    // HTTP Beacons
    .state('pages.main.http_beacons',
    {
        url: '/http_beacons',
        template: require('../views/hunting/http_beacons.html'),
        controller: 'httpBeacons',
        controllerAs: 'page',
        data:
        {
            title: 'HTTP Beacons',
            daterange: true
        }
    })
    // DNS Beacons
    .state('pages.main.dns_beacons',
    {
        url: '/dns_beacons',
        template: require('../views/hunting/dns_beacons.html'),
        controller: 'dnsBeacons',
        controllerAs: 'page',
        data:
        {
            title: 'DNS Beacons',
            daterange: true
        }
    })
};



/** WEBPACK FOOTER **
 ** ./src/pages/routes/hunting.js
 **/